import { InputHTMLAttributes } from "react";
import * as styles from "./style.module.css";

interface IBlock extends InputHTMLAttributes<HTMLDivElement> {
    flexDirection?: "row" | "column";
    expandPadding?: boolean;
}

const Block = ({
    children,
    className,
    expandPadding = false,
    flexDirection = "row",
    ...props
}: IBlock) => {
    const componentClassName =
        styles["container"] +
        (flexDirection ? " " + styles[flexDirection] : "") +
        (expandPadding ? " " + styles.expandPadding + " " : "") +
        (className ? " " + className : "");

    return (
        <div {...props} className={componentClassName}>
            {children}
        </div>
    );
};

export default Block;
